<template>
  <v-dialog
    transition="fade-transition"
    :model-value="modelValue"
    @update:modelValue="clickedOutside"
    :class="getDialogClass(height)"
    :fullscreen="true"
    :persistent="!canCloseDialog"
    style="z-index: 50"
  >
    <v-card class="rounded-t-xl rounded-b-0">
      <div v-if="!hideCloseButton" style="position: fixed; top: 0; width: 100%; z-index: 5" class="text-center">
        <DialogCloseButton :color="color" @click="close" />
      </div>
      <v-container fluid style="height: 100%" :style="styling" class="d-flex flex-column">
        <v-row align="center" justify="center" :align-content="alignContent">
          <v-col cols="12">
            <slot name="default" />
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import DialogCloseButton from './DialogCloseButton.vue'

export default {
  name: 'BottomSheetDialog',
  components: {
    DialogCloseButton,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: null,
    },
    hideCloseButton: {
      type: Boolean,
      default: false,
    },
    canCloseDialog: {
      type: Boolean,
      default: true,
    },
    styling: {
      type: String,
      default: 'padding-bottom: 150px;',
    },
    height: {
      type: String,
      default: 'full',
    },
    alignContent: {
      type: String,
      default: 'end',
    },
  },
  methods: {
    getDialogClass(height) {
      switch (height) {
        case 'variable':
          return 'bottom-sheet-dialog-variable-height'
        case 'half':
          return 'bottom-sheet-dialog-half-height'
        default:
          return 'bottom-sheet-dialog'
      }
    },
    close() {
      this.$emit('close')
    },
    clickedOutside() {
      if (this.canCloseDialog) {
        this.close()
      }
    },
  },
}
</script>
